export default {
  SAVE_LIST_BOOKING: 'SAVE_LIST_BOOKING',
  CLEAR_LIST_BOOKING: 'CLEAR_LIST_BOOKING',
  UPDATE_BOOKING: 'UPDATE_BOOKING',
  CREATE_BOOKING: 'CREATE_BOOKING',
}
